
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.67 18.67l2.22-1.11v-2.78","fill":"none","stroke":"#bac1cd","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M14.22 9.78L12 10.89m0 0L9.78 9.78M12 10.89v2.78m2.22-10.56L12 2 9.78 3.11M5.33 18.67l-2.22-1.11v-2.78","fill":"none","stroke":"#bac1cd","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('g',{attrs:{"data-name":"Group 73","opacity":".4","fill":"none","stroke":"#bac1cd","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"data-name":"Vector","d":"M20.89 6.91l-2.22 1.11M20.89 6.91L18.67 5.8M20.89 6.91v2.78M3.11 6.91L5.33 5.8M3.11 6.91l2.22 1.11M3.11 6.91v2.78M12 22.47l-2.22-1.11M12 22.47l2.22-1.11M12 22.47v-2.78"}})])])
          )
        }
      }
    